import { useCallback, useMemo } from "react";
import { useCallout } from "@folio/stripes/core";
import { useIntl } from "react-intl";
/**
 * Warnings, via stripes callouts, about sending a just saved person to NK
 * authorities (Aleph). The save itself succeeded in both cases.
 *
 * - `notifySendError` warns with Aleph's error text when the person carries a
 *   send error; it answers whether a warning was shown.
 * - `notifySendStatusUnknown` warns that the send status could not be read
 *   back after the save.
 */
export var useAuthoritySendErrorCallout = function () {
    var callout = useCallout();
    var formatMessage = useIntl().formatMessage;
    var notifySendError = useCallback(function (person) {
        var error = person === null || person === void 0 ? void 0 : person.authoritySendError;
        if (!error) {
            return false;
        }
        callout === null || callout === void 0 ? void 0 : callout.sendCallout({
            type: "warning",
            timeout: 0,
            message: formatMessage({ id: "ui-br-agency.person.authoritySend.error.toast" }, { error: error }),
        });
        return true;
    }, [callout, formatMessage]);
    var notifySendStatusUnknown = useCallback(function () {
        callout === null || callout === void 0 ? void 0 : callout.sendCallout({
            type: "warning",
            timeout: 0,
            message: formatMessage({
                id: "ui-br-agency.person.authoritySend.status.unknown",
            }),
        });
    }, [callout, formatMessage]);
    return useMemo(function () { return ({ notifySendError: notifySendError, notifySendStatusUnknown: notifySendStatusUnknown }); }, [notifySendError, notifySendStatusUnknown]);
};
